export default "__VITE_ASSET__DY$ieV_I__"